import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import {OAuthCredentials} from "../types/domain/oauthCredentials";

export const getCompanyCredentials = async (companyId: string): Promise<OAuthCredentials> =>
    await apiClient
        .get<OAuthCredentials>(`/companies/${companyId}/credentials`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const rotateCompanyCredentials = async (companyId: string): Promise<OAuthCredentials> =>
    await apiClient
        .post<OAuthCredentials>(`/companies/${companyId}/credentials/rotate`)
        .then((response) => response.data)
        .catch(handleAxiosError);
